import type { ClaimWorkItem } from '../../../store';
import { useGetUnifiedEncounterClaimWorkspaceQuery } from '../../../store/api';

import { ReasonDetail } from './ReasonDetail';

/** Mount only inside the open popover; share the workbench's existing query cache. */
export const ReasonDetailContainer = ({ item }: { item: ClaimWorkItem }) => {
  const query = useGetUnifiedEncounterClaimWorkspaceQuery(
    { encounterId: item.encounter_id ?? '', claimId: item.claim_id },
    { skip: !item.encounter_id || !item.claim_id },
  );
  return (
    <ReasonDetail
      error={query.isError}
      loading={query.isFetching && !query.currentData}
      payerStatus={item.last_payer_status}
      problem={query.currentData?.problem_summary}
      reason={item.outcome_reason}
    />
  );
};
